import { render, staticRenderFns } from "./FilterByDispatch.vue?vue&type=template&id=5875e462&lang=pug"
import script from "./FilterByDispatch.vue?vue&type=script&lang=js"
export * from "./FilterByDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports